export default {
  affiliate: {
    // Main navigation
    title: 'Đại lý',
    cantFindQuestion: 'Không tìm thấy câu hỏi?',
    onlineService: 'Dịch vụ trực tuyến',
    dashboard: 'Bảng điều khiển',
    myRewards: 'Phần thưởng của tôi',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'Phần thưởng mời',
    rules: 'Quy tắc',

    // Team Info
    teamData: 'Dữ liệu đội',
    details: 'Chi tiết',
    totalValidFriends: 'Tổng số bạn hợp lệ:',
    todayTotalWager: 'Tổng cược hôm nay:',
    rewards: 'Phần thưởng',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Hoa hồng mời bạn lên đến',
    expandTeamBonus: 'Tiền thưởng mở rộng đội',
    maxLevelCommission: 'Hoa hồng cấp tối đa',
    inviteFriendsCommission: 'Hoa hồng mời bạn',
    maxPerformanceCommission: 'Hoa hồng hiệu suất tối đa',
    unlimitedAgent: 'Đại lý không giới hạn',
    unlimitedCommission: 'Hoa hồng không giới hạn',
    commissionRate: 'Tỷ lệ hoa hồng',

    // Team Invite Friends
    inviteFriendsToEarn: 'MỜI BẠN BÈ ĐỂ KIẾM TIỀN',
    link: 'Liên kết',
    code: 'Mã',
    inviteFriends: 'Mời bạn bè',
    share: 'Chia sẻ',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'Nhận',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'Đã nhận hôm nay',

    // Live Rewards
    liveRewards: 'Phần thưởng trực tiếp',
    sendTotalCommission: 'Gửi tổng hoa hồng',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'Mời bạn hôm nay',
    todayDepositFriends: 'Bạn nạp tiền hôm nay',
    depositFriends: 'Bạn nạp tiền',
    validFriends: 'Bạn hợp lệ',

    // Dialogs
    howMakeFriendsSubordinates: 'Cách biến bạn bè thành cấp dưới của bạn:',
    shareInvitationLink: 'Chia sẻ liên kết mời của bạn để họ đăng ký.',
    shareInvitationCode: 'Chia sẻ mã mời của bạn để họ nhập trong quá trình đăng ký.',
    shareQRCode: 'Chia sẻ mã QR của bạn để họ quét và đăng ký.',
    depositFriendsDescription: 'Khi bạn bè cấp dưới của bạn nạp tiền thành công, họ sẽ trở thành bạn bè nạp tiền.',
    howMakeFriendsValidUsers: 'Cách biến bạn bè của bạn thành người dùng hợp lệ:',
    successfullyInviteFriends: 'Mời bạn bè đăng ký thành công.',
    cumulativeDepositsReach: 'Tổng số tiền nạp tích lũy của họ đạt 10.00 USDT.',
    cumulativeValidBetsReach: 'Tổng số tiền cược hợp lệ tích lũy của họ đạt 50.00 USDT.',
    thenBecomeValidUsers: 'Sau đó, họ sẽ trở thành người dùng hợp lệ.',

    // Share Dialog
    shareTitle: 'Chia sẻ',
    player: 'Người chơi',
    saveImage: 'Lưu hình ảnh',
    saveImageSuccess: "Đã lưu hình ảnh",
    saveImageFailed: "Lưu thất bại, vui lòng thử lại",
    copy: 'Sao chép',
    copied: 'Đã sao chép!',

    // Received/Withdraw
    received: 'Đã nhận',
    withdraw: 'Rút tiền',
    history: 'Lịch sử',
    referralRewards: 'Phần thưởng giới thiệu',
    commission: 'Hoa hồng',
    depositRebate: 'Hoàn tiền nạp',
    levelUpRewards: 'Phần thưởng nâng cấp',
    loading: 'Đang tải...',
    noMoreRecords: 'Không còn bản ghi nào',
    loadMore: 'Tải thêm',
    pending: 'Đang chờ',
    paid: 'Đã thanh toán',
    rejected: 'Bị từ chối',
    unknown: 'Không xác định',
    upgradeReward: 'Phần thưởng nâng cấp',
    cancelled: 'Đã hủy',
    receiving: 'Đang nhận',
    failed: 'Thất bại',
    expired: 'Đã hết hạn',

    // History Dialog
    pickDate: 'Chọn ngày',
    select: 'Chọn',
    chooseBonus: 'Chọn tiền thưởng',
    all: 'Tất cả',

    // Invitation Rewards Page
    inviteFriendToGet: 'Mời bạn bè để nhận',
    yourFriendGet: 'Bạn của bạn nhận',
    inviteFriendsEarnRewards: 'Mời bạn bè và nhận phần thưởng',
    dailyInvitations: 'Lời mời hàng ngày',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'Cách kiếm phần thưởng đại lý?',
    shareToFriends: 'Chia sẻ cho bạn bè',
    shareReferralLink: 'Chia sẻ liên kết giới thiệu, mã hoặc mã QR của bạn với bạn bè',
    friendsSignUpDeposit: 'Bạn bè đăng ký và nạp tiền',
    inviteFriendsRegisterDeposit: 'Mời bạn bè đăng ký trên AFUN và thực hiện lần nạp đầu tiên.',
    getUpTo: 'Nhận lên đến',
    earnBigRewards: 'Kiếm phần thưởng & hoa hồng khi bạn bè cược, nạp tiền và đạt VIP.',
    noticeEnsureCorrect: 'Lưu ý: Đảm bảo liên kết mời, mã QR hoặc mã là chính xác.',

    // Rules - Commission Work
    howCommissionWork: 'Hoa hồng hoạt động như thế nào?',
    agentRatingDescription: 'Mô tả xếp hạng đại lý',
    you: 'BẠN',
    commissionDescription: 'Kiếm hoa hồng từ tiền nạp và cược của Bạn bè B, C, D và xa hơn. Xem bảng bên phải để biết tỷ lệ hoa hồng.',
    claimConditions: 'Điều kiện nhận',
    teamLevel: 'Cấp độ đội',
    earnUpTo: "Earn up to",
    expandYourTeam: "Mở Rộng Đội Của Bạn",
    earnAnExtra: "Kiếm Thêm",
    upgradeAgentLevel: "Nâng Cấp Cấp Đại Lý Của Bạn",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'Tổng kích thước',
    teamWager: 'Cược đội',
    rebateRewardVary: 'Phần thưởng hoàn tiền & Phần thưởng nạp tiền thay đổi dựa trên cấp độ đội của bạn vào ngày đó.',
    teamSizeDescription: 'Quy mô đội: Số lượng người dùng hợp lệ bạn hiện có.',
    teamBettingDescription: 'Cược đội: Tổng số lượt cược mà cấp dưới của bạn thực hiện trong một ngày.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'HOA HỒNG NHÓM',
    teamCommissionSubTitle: 'Kiếm tiền từ mỗi lần nạp và\nmỗi cược trong mạng của bạn.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Mời bạn bè và cả hai sẽ nhận được phần thưởng',
    inviteRegisterReceive: 'Mời bạn bè đăng ký thành công và nhận',
    friendDepositWagerUnlock: 'Khi bạn bè của bạn nạp 10.00 USDT và cược 50.00 USDT, bạn mở khóa phần thưởng 3.00 USDT và bạn bè của bạn nhận được 2.00 USDT.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Bạn bè mời gần đây',
    recentDepositFriends: 'Bạn bè nạp tiền gần đây',
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    thisMonth: 'Tháng này',
    friendsData: 'Dữ liệu bạn bè',
    joinDate: 'Ngày tham gia',
    search: 'Tìm kiếm',
    level: 'Cấp',
    tier: 'Bậc',
    affiliateTreasureBox: 'Hộp Kho Báu Đại Lý',
    referralRewardsDesc: 'Khi bạn mời bạn bè đăng ký, cả bạn và bạn bè đều nhận được tiền thưởng hào phóng.',
    commissionDesc: 'Bạn và đội của bạn cùng nhau đạt được mục tiêu và kiếm hoa hồng hào phóng.',
    affiliateTreasureBoxDesc: 'Mời bạn bè để nhận tiền thưởng cột mốc',
  }
};
